import { combineReducers } from '@reduxjs/toolkit';
import rirekishoContact from '@src/store/slices/contact/rirekisho';
import rirekishoHistory from '@src/store/slices/history/rirekisho';
import rirekishoAddress from './address';
import rirekishoBasicInfo from './basic_info';
import rirekishoLicense from './license';
import rirekishoMotivation from './motivation';
import rirekishoOptions from './options';
import rirekishoPersonalRequests from './personal_requests';
import rirekishoPhoto from './photo';

const rirekishoReducer = combineReducers({
  basicInfo: rirekishoBasicInfo,
  currentAddress: rirekishoAddress,
  contact: rirekishoContact,
  history: rirekishoHistory,
  licenses: rirekishoLicense,
  motivation: rirekishoMotivation,
  personalRequests: rirekishoPersonalRequests,
  options: rirekishoOptions,
  photo: rirekishoPhoto,
});

export default rirekishoReducer;
